import { snapshot } from "valtio/vanilla";
import * as API from "../../../api/osMapPrint";
import { abortOsMapPrintRequest } from "./abortOsMapPrintRequest";
import { osMapPrintStore } from "../store";
import { updateStore } from "./updateStore";

export const fetchBounds = async () => {
  updateStore({ syncing: true });
  const { sku_id, orientation, center } = snapshot(osMapPrintStore);
  if (sku_id) {
    abortOsMapPrintRequest();
    const response = await API.fetchBounds({
      sku_id,
      orientation,
      center,
    });

    if (response) {
      const { abort, bounds } = response;
      updateStore({
        activeRequestAbort: abort,
        bounding_box_polygon: bounds.bounding_box_polygon,
      });
    }
  }
  updateStore({ syncing: false });
};
